import {Controller, useForm} from "react-hook-form";
import React from "react";
import NewsletterBenefits from "./NewsletterBenefits";
import {emailRegExp} from "../../../lib/ModalWindow/ForgotPasswordModal";
import Checkbox from "../../../lib/form/Checkbox/Checkbox";
import {Trans, useTranslation} from "react-i18next";
import Spinner from "../../../utils/loader/Spinner";
import {useCustomerContext} from "../../CustomerContextProvider/CustomerContextProvider";
import styles from "./NoNewsletterSubscribtion.module.scss";

const NoNewsletterSubscription: React.FC<{
  customerMail: string | undefined;
  onSubmit: (customerEmail: string) => void;
  isLoading: boolean;
}> = ({customerMail, onSubmit, isLoading}) => {
  const {customer} = useCustomerContext();
  const {t} = useTranslation(["customerAccount", "checkout"]);

  const {
    register,
    watch,
    control,
    handleSubmit,
    formState: {errors},
  } = useForm<{email: string; consent: boolean}>({
    mode: "onChange",
    defaultValues: {email: customerMail || customer.email || "", consent: false},
  });

  const submit = () => {
    if (Object.keys(errors).length !== 0) {
      return;
    }
    onSubmit(watch().email);
  };

  return (
    <React.Fragment>
      <h2>{t("Zum Connox-Newsletter anmelden")}</h2>
      <NewsletterBenefits />
      <form onSubmit={handleSubmit(submit)}>
        <div className={styles.emailInput}>
          <label htmlFor={"newsletter-email"}>{t("Ihre E-Mail Adresse")}</label>
          <input
            id={"newsletter-email"}
            type={"email"}
            {...register("email", {pattern: emailRegExp, required: true})}
          />
          {errors.email?.type === "required" && <span>{t("Bitte ausfüllen")}</span>}
          {errors.email?.type === "pattern" && <span>{t("Bitte geben Sie eine gültige E-Mail-Adresse an")}</span>}
        </div>
        <Controller
          control={control}
          render={({field}) => (
            <Checkbox
              className={errors.consent ? styles.checkboxError : styles.checkbox}
              color={"#0caa00"}
              checked={watch().consent}
              onChange={(checked) => {
                field.onChange(checked);
              }}
            >
              <Trans i18nKey="BinDamitEinverstanden" ns="customerAccount">
                Ich bin damit einverstanden, dass Connox meine
                <a href={t("privacy-link", {ns: "checkout"})} target="_blank" rel={"noreferrer"}>
                  Daten
                </a>
                zu Marketingzwecken verarbeitet (Pflichtangabe)
              </Trans>
            </Checkbox>
          )}
          {...register("consent", {required: true})}
        />
        {errors.consent && (
          <div className={styles.errorMessage}>
            {t("Bitte bestätigen Sie, dass Sie die Datenschutzbestimmungen gelesen haben")}
          </div>
        )}
        <div className={styles.buttonWrapper}>
          <button className={styles.submitBtn} formAction={"submit"}>
            {isLoading ? <Spinner /> : <span>{t("Zum Connox-Newsletter anmelden")}</span>}
          </button>
        </div>
      </form>
    </React.Fragment>
  );
};

export default NoNewsletterSubscription;
